import React from "react";
import { IControlProps, INumberControl } from "./types";
import forBasicControl from "./forBasicControl";
import { FormGroup, Input, InputGroupText, InputGroup, InputGroupAddon } from "reactstrap";
import { createLabel } from "./BasicControls";
import { LocaleSettings, parseNumber } from "../../global/formatting";
import LabelWithToolTip from "../LabelWithToolTip";

interface IState {
    value: number;
    text: string;
}
class NumberControl extends React.PureComponent<IControlProps<number, INumberControl>, IState> {
    constructor(props: IControlProps<number, INumberControl>) {
        super(props);

        this.state = {
            text: '',
            value: null,
        };

    }
    private formatter: Intl.NumberFormat;

    public componentDidMount() {
        this.updateFormat();

        this.setState({
            value: this.props.value,
            text: this.format(this.props.value),
        });
    }
    public componentDidUpdate(prev: IControlProps<number, INumberControl>) {
        this.updateFormat();

        if (this.props.value !== prev.value && this.props.value !== this.state.value) {
            this.setState({
                value: this.props.value,
                text: isNaN(this.props.value) ? this.state.text : this.format(this.props.value),
            });
        }
    }
    private format(value: number) {
        if (isNaN(value))
            return this.state.text || '';
        return typeof (value) === 'number' ? this.formatter.format(value) : ''
    }
    private updateFormat() {
        this.formatter = new Intl.NumberFormat(LocaleSettings.Locale, { style: 'decimal', minimumIntegerDigits: 1, minimumFractionDigits: this.props.definition.config.fractionDigits, maximumFractionDigits: this.props.definition.config.fractionDigits });
    }
    private onChange(value: string) {
        const parsed = parseNumber(value);
        const emit = parsed !== this.state.value;
        this.setState({
            text: value,
            value: parsed,
        });

        if (emit)
            this.props.onChange(parsed, false);
    }
    private onBlur() {
        const text = this.format(this.props.value);
        if (text !== this.state.text)
            this.setState({ text });

        this.props.onBlur();
    }
    public render() {
        const props = this.props;
        return <>
            <FormGroup className={[props.definition.config.currency ? "currency-field" : "", props.showValidation ? props.isValid ? 'is-valid' : 'is-invalid' : ''].join(' ')}>
                <LabelWithToolTip
                    label={createLabel(props.definition, true)}
                    field={props.definition.key}
                    tooltip={props.definition.config.description} />

                <InputGroup className={props.showValidation ? props.isValid ? 'is-valid' : 'is-invalid' : ''}>
                    <InputGroupAddon addonType="prepend">
                        {props.definition.config.currency && <InputGroupText><i className="mdi mdi-currency-eur" aria-label="Euro" /></InputGroupText>}
                    </InputGroupAddon>

                    <Input
                        aria-label={createLabel(props.definition)}
                        id={this.props.definition.key}
                        invalid={props.showValidation && !props.isValid}
                        onBlur={() => this.onBlur()}
                        onChange={(evt) => this.onChange(evt.target.value)}
                        placeholder={createLabel(props.definition, true)}
                        readOnly={props.readOnly}
                        title={props.definition.config.description || createLabel(props.definition)}
                        type='text'
                        valid={props.showValidation && props.isValid}
                        value={this.state.text}
                    />
                </InputGroup>

                {!props.isValid && <div className="invalid-feedback">{props.validationMessage}</div>}
            </FormGroup>
        </>
    }
}

export default forBasicControl(NumberControl);